import get from 'lodash.get';
import { useEffect } from 'react';
import { handleTrack } from '../../../../utils/tracker';
import { ISINGLE_POST } from '../types';

export const useOnMountCMSLayout = (cmsData: ISINGLE_POST): void => {
  useEffect(() => {
    window.handleTrack = handleTrack;
    window.categoryName = get(cmsData, ['category', 'slug'], 'Uncategorized');
    window.parentCategory = get(
      cmsData,
      ['category', 'parent', 'name'],
      window.categoryName
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
